import React, { useState, useEffect } from 'react';
import logo from './logo.svg';
import './App.css';
import Sidebar from './components/sidebar/Sidebar';
import Topbar from './components/topbar/Topbar';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Home from './pages/home/Home.jsx';
import Decoding from './pages/decoding/Decoding';

import Login from './pages/login/Login';
import Information from './pages/information/Information';

const renderProtectedRoute = (Component, token) => {
  if (token==='Success') {
    return Component;
  } else {
    return <Navigate to="/login" />;
  }
};

function App() {

  const token = 'Success'; 
  
  return (
    <Router>
      
        <Routes>
          <Route path="/" element={renderProtectedRoute(<Home/>, token)}></Route>
          <Route path="/login" element={<Login />}></Route>
          <Route path="/home" element={renderProtectedRoute(<Home/>, token)}></Route>
          <Route path="/decoding" element={renderProtectedRoute(<Decoding/>, token)}></Route>
          <Route path="/information" element={renderProtectedRoute(<Information/>, token)}></Route>
          {/*<Route path="/dataset_analysis" element={<DatasetAnalysis/>}></Route>*/}
        </Routes>
      
    </Router>

  );
}

export default App;